export default {
  userRole(state, getters) {
    return state.userRole
  }
  
}